import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

import styles from "./style";
import { FormattedMessage } from "react-intl";

const GoBackButton = ({ style }) => {
  const navigation = useNavigation();

  const goBack = () => {
    navigation.goBack();
  };

  return (
    <TouchableOpacity onPress={goBack} style={[styles.btnVoltar, style]}>
      <Text style={styles.btnVoltarText}>
        <FormattedMessage id="goBackButton.labelVoltar" />
      </Text>
    </TouchableOpacity>
  );
};

export default GoBackButton;
